<template>
  <header>
    <span class="title">
      <i class="el-icon-s-flag"></i>
      {{ $t(`menu.${menuTitle}`) }}
    </span>
    <span class="dropdown">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link"
        >{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="Logout" divided
          >退 出</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </header>
</template>
<script>
import Cookies from "js-cookie";

export default {
  name: "Header",
  computed: {
    menuTitle() {
      return this.$store.getters.menuTitle;
    }
  },
  mounted() {
    let userName = localStorage.getItem("userName")
    this.userName = userName
  },
  data() {
    return {
      userName: "用户名"
    };
  },
  methods: {
    Logout() {
      this.$store.commit("setToken", "");
      this.$store.commit("setAccount", "");
      Cookies.set("token", "");
      Cookies.set("account", "");
      // this.$router.push('/login')
      window.location.replace("https://uat.lingshutong.cn/#/login")
    }
  }
};
</script>
<style lang="sass" scoped>
header
  height: 60px
  width: 100%
  background: #fff
  box-shadow: 0 3px 3px rgba(0, 0, 0, .15)
  line-height: 60px
  padding: 0 20px

  .title
    color: #ababab
    font-size: 18px

  .dropdown
    cursor: pointer
    float: right
    margin-right: 50px
    user-select: none
</style>



// WEBPACK FOOTER //
// src/opr/pages/layout/Header.vue